export default __webpack_public_path__ + "static/mercado-automotivo-450c21b3ddf2029b0a2b24229bb679a4.png";